import {
  ApiGetRequest,
  ApiBlobGetRequest,
  ApiPostRequest,
  // ApiPostRequest,
  // ApiDeleteRequest,
  // ApiPutRequest,
} from '../../../api';
import moment from 'moment-mini';
import { showNotif } from '../../notification';

export const state = {
  data: {
    title: 'Report - Daily',
    breadcrumb: [
      {
        text: 'Dashboard',
        href: '/adm/opr/report',
      },
      {
        text: 'Report - Daily',
        href: '/adm/opr/report/daily',
        active: true,
      },
    ],
    showmodal: false,
    items: [],
    total: 0,
    page: 1,
    limit: 10,
    pageOptions: [10, 25, 50, 100],
    search: '',
    sortBy: 'id_daily_report',
    sortDesc: true,
    export: 0,
    fields: [
      {
        key: 'report_add',
        label: 'Tanggal',
      },
      {
        key: 'code_dr',
        label: 'Kode',
      },
      {
        key: 'principle',
        label: 'Principle',
      },
      {
        key: 'type_report',
        label: 'Type',
      },
      {
        key: 'start_date',
        label: 'Start Date',
      },
      {
        key: 'end_date',
        label: 'End Date',
      },
      {
        key: 'time',
        label: 'Time',
      },
      {
        key: 'email_to',
        label: 'To',
      },
      {
        key: 'report_send',
        label: 'Send',
      },
      // {
      //   key: 'report_file',
      //   label: 'Download',
      // },
      {
        key: 'report_status',
        label: 'Status',
      },
      {
        key: 'aksi',
        label: 'Aksi',
      },
    ],
    detail: false,
    form: {
      id_user: '',
      name: '',
    },
  },
};

export const getters = {
  form(state) {
    return state.data.form;
  },
};

export const mutations = {
  reportDaily(state, data) {
    state.data = Object.assign({}, state.data, data);
  },
};

export const actions = {
  async getReportDaily({ commit, state }) {
    commit('reportDaily', {
      loading: true,
    });

    const { data } = state;
    let params = {
      q: data.search,
      limit: data.limit,
      page: data.page,
      sort: data.sortBy,
      order: data.sortDesc ? 'desc' : 'asc',
      ...data.form,
      date: data.form.date ? moment(data.form.date).format('YYYY-MM-DD') : '',
    };
    let result = await ApiGetRequest(`opr/report/daily`, params);
    commit('reportDaily', {
      items: result.data.object || [],
      total: result.data.total || 0,
      loading: false,
    });

    return result.error ? false : true;
  },

  async getExportReportDaily({ commit, state }) {
    commit('reportDaily', {
      loading: true,
    });

    const { data } = state;
    let params = {
      q: data.search,
      page: data.page,
      sort: data.sortBy,
      order: data.sortDesc ? 'desc' : 'asc',
      ...data.form,
      date: data.form.date
        ? moment(new Date(data.form.date)).format('YYYY-MM-DD')
        : '',
      export: 1,
    };

    let result = await ApiBlobGetRequest(`opr/report/daily`, params);
    commit('reportDaily', {
      loading: false,
    });

    if (result.error) {
      return false;
    } else {
      // The actual download
      var blob = new Blob([result.data], {
        type:
          'application/vnd.openxmlformats-officedocument.spreadsheetml.sheet',
      });
      var link = document.createElement('a');
      link.href = window.URL.createObjectURL(blob);
      link.download = 'report_daily.xlsx';

      document.body.appendChild(link);

      link.click();
      document.body.removeChild(link);

      return true;
    }
  },

  async resendEmailDaily({ commit, dispatch }, payload = null) {
    commit('reportDaily', {
      loading: true,
    });

    let result = await ApiPostRequest(`opr/report/daily-resend`, payload);
    commit('reportDaily', {
      loading: false,
    });

    if (!result.error) {
      showNotif(dispatch, {
        message: result.data.message,
        type: 'success',
      });
    }

    return result.error ? false : true;
  },

  async downloadDataExcel({ commit }, payload = null) {
    commit('reportDaily', {
      loading: true,
    });

    let result = await ApiGetRequest(`opr/report/daily-download/${payload.id}`);
    commit('reportDaily', {
      loading: false,
    });

    if (result.error) {
      return false;
    } else {
      // The actual download
      // var blob = new Blob([result.data], {
      //   type:
      //     'application/vnd.openxmlformats-officedocument.spreadsheetml.sheet',
      // });
      // var link = document.createElement('a');
      // link.href = window.URL.createObjectURL(blob);
      // link.download = 'report_daily.xlsx';

      // document.body.appendChild(link);

      // link.click();
      // document.body.removeChild(link);

      return result.data.object || false;
    }
  },
};
